import { render } from "./ModulesList.vue?vue&type=template&id=740a8306&scoped=true"
import script from "./ModulesList.vue?vue&type=script&lang=js"
export * from "./ModulesList.vue?vue&type=script&lang=js"

import "./ModulesList.vue?vue&type=style&index=0&id=740a8306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740a8306"]])

export default __exports__